/* eslint-disable no-shadow,consistent-return,no-param-reassign */

const state = {
  // Set default state(s) here
  sidebar: false,
};

const mutations = {
  setSidebar(state, payload) {
    state.sidebar = payload;
  },
};

const actions = {
  toogleSidebar({ commit }, data) {
    commit('setSidebar', data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreSetting.js